<template>
  <hm-col :id="$attrs['id']" cols="12" style="position: relative;" class="align-content-center">
    <blockquote class="card-action" @click="$emit('click')">
      <span class="icon"><i class="fal fa-plus"></i></span>
      <p v-html="title" />
    </blockquote>
  </hm-col>
</template>

<script>

import { isNil, isEmpty } from 'lodash';
import GridMixin from '@/mixins/GridMixin';

export default {
  name: 'Quote',

  mixins: [GridMixin],

  props: {
    title: {
      type: String,
      default: '',
    },
  },

  data: function () {
    return {
    };
  },

  created: function () {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .card-action {
    padding: 2.5rem 2.5rem;
    margin: 0;
    position: relative;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    justify-items: center;
    align-items: center;
    justify-content: center;
    align-content: center;
    cursor: pointer!important;
    transition: all 0.2s ease;

    cite {
      color: $gray;
      position: relative;
      margin-left: 25px;
      &:before {
        position: absolute;
        content: ' ';
        left: -25px;
        width: 20px;
        height: 1px;
        top: calc(50% - 1px);
        background: $mint;
        background: $blue;
      }
    }

    p {
      margin-top: 4.5rem;
      font-size: 1.6rem;
      text-align: center;
      color: $gray;
      //color: $blue;
    }

    .icon {
      top: 2.5rem;
      left: 50%;
      position: absolute;
      font-size: 4rem;
      line-height: 4rem;
      height: 50px;
      transform: translateX(-50%);
      color: $middlemint;
      //text-shadow: 0.1rem 0.1rem 0.2rem rgba($black,0.5);
      color: $blue;
    }

    &:hover {
      .icon {
        color: $mint;
        color: $blue;
      }

      p {
        color: $text;
        color: $blue;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/CardAction.vue